export default __webpack_public_path__ + "static/media/icon-Beneficio02.f809cd2a.svg";